import { Player } from '@lottiefiles/react-lottie-player';
import { useEffect, useRef } from 'react';
import animationData from '../assets/NewSureLoader.json';
import './SureLoader.css';

interface SureLoaderProps {
  fullscreen?: boolean;
}

const SureLoader = ({ fullscreen = false }: SureLoaderProps) => {
  const playerRef = useRef(null);

  useEffect(() => {
    if (playerRef.current) {
      playerRef.current.play(); // Start animation on first render
    }
  }, []);

  return (
    <div className={fullscreen ? 'fullscreen-loader' : 'loader-wrapper'}>
      <div className="lottie-animation-container">
        <Player
          ref={playerRef}
          autoplay
          loop={true}
          src={animationData}
          style={{
            width: fullscreen ? '50px' : '50px',
            height: fullscreen ? '50px' : '50px',
          }}
        />
      </div>
    </div>
  );
};

export default SureLoader;
